export const INPUT_DELAY_TIME = 10000;
export const DEFAULT_BET_VALUE = 0.01;